var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('Header'),_c('div',{staticClass:"content"},[_c('ResetFeedbackMessage',{attrs:{"customerEmail":_vm.theCustomerEmail,"here":'login'}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }